/*
 * @Author: Chao Yang
 * @Date: 2020-09-08 10:02:53
 * @LastEditor: Chao Yang
 * @LastEditTime: 2021-09-09 07:04:22
 */
import { Injectable } from '@angular/core';
import { OfferingProxy } from '../../proxy/offering/offering.proxy';
import { OfferingDetailLayout } from '../../model/offering/offeringDetailLayout.model';
import { Observable } from 'rxjs';
import { OfferingDetailSummary } from '../../model/offering/offeringDetailSummary.model';
import { OfferingDetailContact } from '../../model/offering/offeringDetailContact.model';
import { OfferingDetailDocument } from '../../model/offering/offeringDetailDocument.model';
import { OfferingDetailFolder } from '../../model/offering/offeringDetailFolder.model';
import { ITrackRecord } from '../../model/offering/editor/i-track-record.model';
import { map } from 'rxjs/operators';
import { isNumber } from 'util';

@Injectable()
export class OfferingService {
  constructor(private offeringProxy: OfferingProxy) { }
  getOfferingDetailLayout(fundId: number): Observable<OfferingDetailLayout> {
    return this.offeringProxy.getOfferingDetailLayout(fundId);
  }

  getOfferingDetailSummary(fundId: number): Observable<OfferingDetailSummary> {
    return this.offeringProxy.getOfferingDetailSummary(fundId);
  }

  getOfferingDetailContact(
    fundId: number
  ): Observable<OfferingDetailContact[]> {
    return this.offeringProxy.getOfferingDetailContact(fundId);
  }

  getOfferingDetailDocument(
    fundId: number,
    userId: number
  ): Observable<OfferingDetailFolder[]> {
    return this.offeringProxy.getOfferingDetailDocument(fundId).pipe(
      map((list) => {
        var result = list.filter((f) => f.count > 0);
        list.forEach(f => {
          this.removeEmptySubFolders(f);
        });
        return result;
      })
    );
  }

  removeEmptySubFolders(f: any) {
    if (f.folders != null) {
      f.folders = f.folders.filter(sf => sf.count > 0);
      f.folders.forEach(sf => {
        this.removeEmptySubFolders(sf);
      });
    }
  }

  getMarketingFundTypeName(type: string | null): string | null {
    switch (type) {
      case '1909':
        return 'Open Ended';
      case '1910':
        return 'Closed Ended';
      case '1911':
      case null:
        return '';
      default:
        return '';
    }
  }

  getOfferingDetailImages(fundId: number) {
    return this.offeringProxy.getOfferingDetailImages(fundId);
  }
  getOfferingDetailVideos(fundId: number) {
    return this.offeringProxy.getOfferingDetailVideos(fundId);
  }

  getFundBannerImage(fundId: number): Observable<string> {
    return this.offeringProxy.getFundBannerImage(fundId);
  }

  getTrackRecord(fundId: number): Observable<ITrackRecord> {
    return this.offeringProxy.getTrackRecord(fundId);
  }
}
